import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'atlas-copyright-notices',
    templateUrl: './copyright-notices.component.html',
    styleUrls: ['./copyright-notices.component.less'],
    standalone: false
})
export class CopyrightNoticesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
